"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Theme = void 0;
/**
 * This is a list of valid prefixes for theme tokens.
 * The same prefix/theme name can be used for multiple token types.
 * Refer to list of token types here: https://github.expedia.biz/egds/tools/blob/master/packages/types/src/token.ts
 * Enum keys should use dashes and values should use underscores.
 * ThemeProvider uses these enum keys to set the body's data-theme tag. This tools repo uses enum values to resolve token values.
 */
var Theme;
(function (Theme) {
    Theme["none"] = "none";
    Theme["light-1"] = "light_1";
    Theme["dark-1"] = "dark_1";
    Theme["bright-1"] = "bright_1";
    Theme["global-loyalty-standard"] = "global_loyalty_standard";
    Theme["global-loyalty-low"] = "global_loyalty_low";
    Theme["global-loyalty-low-bright"] = "global_loyalty_low_bright";
    Theme["global-loyalty-mid"] = "global_loyalty_mid";
    Theme["global-loyalty-mid-bright"] = "global_loyalty_mid_bright";
    Theme["global-loyalty-high"] = "global_loyalty_high";
    Theme["global-loyalty-high-bright"] = "global_loyalty_high_bright";
    Theme["global-loyalty-extra-high"] = "global_loyalty_extra_high";
    Theme["global-loyalty-extra-high-bright"] = "global_loyalty_extra_high_bright";
    Theme["standard"] = "standard";
    Theme["marketing-1"] = "marketing_1";
    Theme["marketing-2"] = "marketing_2";
})(Theme = exports.Theme || (exports.Theme = {}));
//# sourceMappingURL=theme.js.map